import * as React from "react"

import {UNMATCHED_ROUTES} from "@constants";
import PageWrapper from "../../@PageWrapper";
import UnmatchedNewProductsFiltersBlock from "./FiltersBlock";
import UnmatchedNewProductsTable from "./Table";
import UnmatchedNewProductsMappingDrawer from "./MappingDrawer";


export default function UnmatchedNewProductsPage() {

    return <PageWrapper
        head={`SKU Mapper | ${UNMATCHED_ROUTES.NEW_PRODUCTS_SUBTITLE}`}
        title={UNMATCHED_ROUTES.TITLE}
        subtitle={UNMATCHED_ROUTES.NEW_PRODUCTS_SUBTITLE}
    >
       <UnmatchedNewProductsFiltersBlock />
       <UnmatchedNewProductsTable />
       <UnmatchedNewProductsMappingDrawer />
       {/* <UnmatchedNewProductsSkuFormDrawer /> */}
    </PageWrapper>
}